












import { Component, Vue } from 'vue-property-decorator';
import VTag from '@/components/VTag.vue';

@Component({
  components: { VTag }
})
export default class HomePopularTagList extends Vue {
  mounted() {
    this.$store.dispatch('home/fetchTags');
  }

  get tags() {
    return this.$store.getters['home/getTags'];
  }
}
